module.exports = __webpack_public_path__ + "static/media/onboarding-sidebar.ec421018.svg";